import { render, staticRenderFns } from "./InterfaceManage.vue?vue&type=template&id=a8f1853a&scoped=true&"
import script from "./InterfaceManage.vue?vue&type=script&lang=js&"
export * from "./InterfaceManage.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceManage.vue?vue&type=style&index=0&id=a8f1853a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f1853a",
  null
  
)

export default component.exports